//#region src/utils/facets.ts
const MAX_FACETS = 5;
function normalizeFacets(facets = []) {
	const facetsMap = /* @__PURE__ */ new Map();
	for (const facet of facets) {
		const key = facet.key.trim().toLowerCase();
		if (key.length === 0 || facetsMap.has(key)) continue;
		if (facetsMap.size >= 5) break;
		facetsMap.set(key, facet);
	}
	return Array.from(facetsMap.values());
}
function getFacetLabel(facet) {
	if (facet.label) return facet.label;
	return facet.key.replace(/[._-]+/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase());
}
/**
* Extracts the facet key from an Algolia `facetFilters` string entry such as
* `language:en`. Returns `null` when the entry doesn't have a `key:value`
* shape.
*/
function getFacetFilterKey(facetFilter) {
	const separatorIndex = facetFilter.indexOf(":");
	return separatorIndex <= 0 ? null : facetFilter.slice(0, separatorIndex);
}
function parseFacetFilter(facetFilter) {
	const key = getFacetFilterKey(facetFilter);
	if (key === null) return null;
	const value = facetFilter.slice(key.length + 1);
	return value ? {
		key,
		value
	} : null;
}
/**
* Reads the initial facet selections from the configured `facetFilters` of each
* index. Later indices override earlier ones for the same facet key.
*
* - A `key:value` string selects a single value.
* - A nested OR group whose entries all share the same key (for example
*   `['docusaurus_tag:default', 'docusaurus_tag:docs-default-current']`)
*   selects every value in the group.
* - OR groups that mix facet keys can't map to a single facet and are ignored.
*/
function deriveDefaultSelectedFacetsFromIndex(indices) {
	const defaultFacets = {};
	for (const index of indices) {
		var _index$searchParamete;
		const facetFilters = (_index$searchParamete = index.searchParameters) === null || _index$searchParamete === void 0 ? void 0 : _index$searchParamete.facetFilters;
		for (const facetFilter of Array.isArray(facetFilters) ? facetFilters : [facetFilters]) {
			if (typeof facetFilter === "string") {
				const parsed = parseFacetFilter(facetFilter);
				if (parsed) defaultFacets[parsed.key] = [parsed.value];
				continue;
			}
			if (!Array.isArray(facetFilter) || facetFilter.length === 0) continue;
			let groupKey = null;
			const groupValues = [];
			for (const entry of facetFilter) {
				const parsed = typeof entry === "string" ? parseFacetFilter(entry) : null;
				if (!parsed || groupKey !== null && parsed.key !== groupKey) {
					groupKey = null;
					break;
				}
				groupKey = parsed.key;
				groupValues.push(parsed.value);
			}
			if (groupKey !== null) defaultFacets[groupKey] = groupValues;
		}
	}
	return defaultFacets;
}

//#endregion
export { normalizeFacets as i, getFacetFilterKey as n, getFacetLabel as r, deriveDefaultSelectedFacetsFromIndex as t };
//# sourceMappingURL=facets-BgrvW4xW.js.map